import { db } from "../firebase";

import {
  collection,
  addDoc,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";

export const getIdByPlayerId = async (playerId) => {
  let querySnapshot;
  try {
    const playerIdString = String(playerId);
    const q = query(
      collection(db, "players"),
      where("id", "==", playerIdString)
    );
    querySnapshot = await getDoc(q);

    if (querySnapshot.exists()) {
      console.log("Nalezený hráč:", querySnapshot.data());
      const playerDoc = querySnapshot.docs[0];
      return playerDoc.id;
    } else {
      console.log("Hráč s ID " + playerId + " neexistuje");
      return undefined;
    }
  } catch (error) {
    console.error("Chyba při načítání hráče:", error);
    return undefined;
  }
};
// Přidání nového záznamu
export const addPlayer = async (data) => {
  const newDocRef = doc(collection(db, "players"));
  const uniqueId = newDocRef.id;
  const playerWithId = { ...data, id: uniqueId };
  try {
    const docRef = await addDoc(collection(db, "players"), {
      ...playerWithId,
      createdAt: new Date(),
    });
    console.log("Document written with ID: ", docRef.id);
    return docRef.id;
  } catch (e) {
    console.error("Error adding document: ", e);
    throw e;
  }
};

// Získání všech záznamů
export const getAllPlayers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "players"));
    const results = [];
    querySnapshot.forEach((doc) => {
      results.push({
        docId: doc.id,
        ...doc.data(),
      });
    });
    return results;
  } catch (e) {
    console.error("Error getting documents: ", e);
    throw e;
  }
};

// Získání jednoho záznamu podle ID
export const getPlayerById = async (id) => {
  try {
    const docRef = doc(db, "players", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
      };
    } else {
      throw new Error("Document doesn't exist");
    }
  } catch (e) {
    console.error("Error getting document: ", e);
    throw e;
  }
};

// Aktualizace záznamu
export const updatePlayer = async (player) => {
  try {
    const docRef = doc(db, "players", player.docId);
    delete player.docId;
    await updateDoc(docRef, {
      ...player,
      updatedAt: new Date(),
    });
    return true;
  } catch (e) {
    console.error("Error updating document: ", e);
    throw e;
  }
};

// // Smazání záznamu
export const deletePlayer = async (playerId) => {
  try {
    await deleteDoc(doc(db, "players", getIdByPlayerId(playerId)));
    return true;
  } catch (e) {
    console.error("Error deleting document: ", e);
    throw e;
  }
};

// // Vyhledávání záznamů podle pole
export const getAllResults = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "results"));
    const results = [];
    querySnapshot.forEach((doc) => {
      results.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    return results;
  } catch (e) {
    console.error("Error getting documents: ", e);
    throw e;
  }
};

export const addResult = async (data) => {
  try {
    const docRef = await addDoc(collection(db, "results"), {
      ...data,
      createdAt: new Date(),
    });
    console.log("Document written with ID: ", docRef.id);
    return docRef.id;
  } catch (e) {
    console.error("Error adding document: ", e);
    throw e;
  }
};

// Úprava turnaje (popis, komentář…)
export const updateResult = async (docId, data) => {
  try {
    await updateDoc(doc(db, "results", docId), {
      ...data,
      updatedAt: new Date(),
    });
    return true;
  } catch (e) {
    console.error("Error updating result: ", e);
    throw e;
  }
};

// Smazání jednoho turnaje
export const deleteResult = async (docId) => {
  try {
    await deleteDoc(doc(db, "results", docId));
    return true;
  } catch (e) {
    console.error("Error deleting result: ", e);
    throw e;
  }
};

// Smazání všech turnajů. Vrací počet skutečně smazaných záznamů.
export const deleteAllResults = async () => {
  const querySnapshot = await getDocs(collection(db, "results"));
  let deleted = 0;
  for (const docSnap of querySnapshot.docs) {
    await deleteDoc(doc(db, "results", docSnap.id));
    deleted++;
  }
  return deleted;
};
